import { action, payload } from "ts-action";
import { Question,QuestionDiscussion } from "../../@types/question.interface";

export interface IInsertQuestionPayload {
    name: "INSERT_QUESTION";
    data: {
        quiz_id: number;
        question_type_id: number;
        question_number: number;
        question_quiz: string;
        weight_score: number;
        reason_answer: string;
        question_answer: { key: string }[];
        question_choice: { answer: string }[];
    };
}

export interface IFetchQuestionsPayload {
    name: "QUESTIONS";
    data: {
        id: number;
    };
}

export interface IFetchQuestionAnswerPayload {
    name: "QUESTIONS_DISCUSSION";
    data: {
        id: number;
    }
}

export interface IFetchQuestionPayload {
    name: "QUESTION";
    param: {
        quiz_id: number;
    };
    data: {
        question_number: number;
    };
}

export interface IUpdateQuestionPayload {
    name: "UPDATE_QUESTION";
    data: {
        quiz_id: number;
        question_type_id: number;
        question_id: number;
        question_quiz: string;
        weight_score: number;
        question_answer: { key: string }[];
        question_choice: { answer: string }[];
    };
}

export interface IDeleteQuestionPayload {
    name: "DELETE_QUESTION";
    data: {
        quiz_id: number;
        question_id: number;
    };
}

export const QUESTIONS = "QUESTIONS";
export const QUESTION = "QUESTION";
export const CLEAR_QUESTIONS = "CLEAR_QUESTIONS";
export const CLEAR_QUESTION = "CLEAR_QUESTION";
export const DELETE_QUESTION = "DELETE_QUESTION";
export const QUESTIONS_DISCUSSION = "QUESTIONS_DISCUSSION";
export const CLEAR_QUESTION_DISCUSSION = "CLEAR_QUESTION_DISCUSSION";

export const fetchQuestions = action(
    QUESTIONS,
    payload<{ questions: Question[] }>()
);
export const fetchQuestion = action(
    QUESTION,
    payload<{ question: Question }>()
);

export const fetchQuestionDiscussion = action(
    QUESTIONS_DISCUSSION,
    payload<{ question_answer: QuestionDiscussion[] }>()
)
export const clearQuestion = action(CLEAR_QUESTION);
export const clearQuestions = action(CLEAR_QUESTIONS);
export const clearQuestionDiscussion = action(CLEAR_QUESTION_DISCUSSION);

export type QuestionActionType =
    | ReturnType<typeof fetchQuestions>
    | ReturnType<typeof fetchQuestion>
    | ReturnType<typeof clearQuestions>
    | ReturnType<typeof fetchQuestionDiscussion>
    | ReturnType<typeof clearQuestionDiscussion>
    | ReturnType<typeof clearQuestion>;

const QuestionActionAPI = {
    clearQuestions,
    clearQuestion,
    clearQuestionDiscussion
};

export default QuestionActionAPI;
